import { Routes, Route, Navigate } from 'react-router-dom'
import { AppProvider } from './lib/store'
import { LoginPage } from './pages/LoginPage'
import { RoleSelect } from './pages/RoleSelect'
import { ParentPanel } from './pages/ParentPanel'
import { CreateHunt } from './pages/CreateHunt'
import { EditHunt } from './pages/EditHunt'
import { GameView } from './pages/GameView'
import { HuntComplete } from './pages/HuntComplete'

export function App() {
  return (
    <AppProvider>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/role" element={<RoleSelect />} />
        <Route path="/parent" element={<ParentPanel />} />
        <Route path="/parent/create" element={<CreateHunt />} />
        <Route path="/parent/edit/:huntId" element={<EditHunt />} />
        <Route path="/play/:huntId" element={<GameView />} />
        <Route path="/complete/:huntId" element={<HuntComplete />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppProvider>
  )
}
